import { useEffect, useState, useCallback, useRef, useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/camelcase
import { unstable_batchedUpdates } from 'react-dom';
import { useContextSelector, useContext } from 'use-context-selector';
import { StickyControlContext, StickyValueContext } from './StickyContext';
import { DEFAULT_STICKY_STATE, } from './stickyEmulation';
import { useBaseSticky } from './useBaseSticky';
import { quantizeSize } from './utils';
export function useSticky(options, containerRef, childRef, initialState = DEFAULT_STICKY_STATE) {
    const stickyControlContext = useContext(StickyControlContext);
    if (stickyControlContext == null) {
        throw new Error('StickyContext is not provided');
    }
    const stickyIdRef = useRef(null);
    const stickyId = stickyIdRef.current || stickyControlContext.register();
    stickyIdRef.current = stickyId;
    const [state, setState] = useState(initialState);
    const itemState = useContextSelector(StickyValueContext, (context) => {
        if (context == null) {
            return null;
        }
        return context.entries[stickyId];
    });
    const handleUpdate = useCallback((state) => {
        unstable_batchedUpdates(() => {
            stickyControlContext.update(stickyId, containerRef, options, state);
            setState(state);
        });
    }, [
        stickyControlContext.update,
        stickyId,
        containerRef,
        options,
        setState,
    ]);
    const augmentedOptions = useMemo(() => ({
        ...options,
        offset: quantizeSize(((itemState && itemState.accumulatedOffset) || 0) + options.offset),
    }), [options, itemState && itemState.accumulatedOffset]);
    useBaseSticky(state, handleUpdate, augmentedOptions, containerRef, childRef);
    useEffect(() => {
        // Unregister on unmount
        return () => {
            stickyControlContext.unregister(stickyId);
        };
    }, [stickyId]);
    return state;
}
//# sourceMappingURL=useSticky.js.map